module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/4e31388928e21ac08aec270f96eecaa2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_group.svg
// module id = 5qXz
// module chunks = 0